import React, { useState,useEffect } from "react";
import { TextField, Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Input } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faApple } from "@fortawesome/free-brands-svg-icons";
import faGoogle from "../Assests/Google.png";
import faFacebook from "../Assests/Facebook.png";
import { useNavigate } from "react-router-dom";
import { AuthService, confirmSignUp, setMfaToEmail, signUp } from "../Services/AuthService"; // Assume AuthService handles Cognito signup/confirmation
import { handleUserSignup, emailValidation } from "../Services/ShowsApi";
import ErrorModal from "../Components/ErrorModal";
import logo from "./../Assests/Rectangle 36.png";
import arrowSignup from "../Assests/Vector 4.png";
import "./Pages.css";
import { Tooltip } from "@mui/material"; // Import Tooltip
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons"; // Import FontAwesome Info Circle icon

import { useGoogleLogin } from "@react-oauth/google";
import { v4 as uuidv4 } from 'uuid';
import logger from "redux-logger";
import { FormControl, FormLabel,InputAdornment} from '@mui/material';
import { FormHelperText } from '@mui/material';
import PasswordValidationHelper from '../Components/PasswordValidationHelper';
import LogoWithGradient from '../Components/LogoWithGradient/LogoWithGradient';
import LogoAnimation from "../Components/LogoAnimation";
import { buttonStyles, passwordValidationStyles, inputFieldStyles, smallInputFieldStyles } from "../utils/constant";




function Signup() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmationCode, setConfirmationCode] = useState("");
  const [isConfirming, setIsConfirming] = useState(false);
  const [userId, setUserId] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [popup, setPopup] = useState({ open: false, title: "", message: "" });
  const handlePopupClose = () => setPopup({ open: false, title: "", message: "" });
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const [passwordValidation, setPasswordValidation] = useState({
    minLength: false,
    hasNumber: false,
    hasSpecialChar: false,
    hasUppercase: false,
    hasLowercase: false
  });

  const lastNameRef = React.useRef(null);
  const signupUsernameRef = React.useRef(null);
  const signupEmailRef = React.useRef(null);
  const signupPasswordRef = React.useRef(null);
  const confirmCodeRef = React.useRef(null);


  // Add the Cognito hosted domain and app client details here
  const cognitoDomain = "authentication.dyrect-dev.ai"; // e.g., myapp.auth.us-east-1.amazoncognito.com
  const clientId = process.env.REACT_APP_CLIENT_ID;
  const redirectUri = "http://localhost:3000/shows"; // Make sure this matches your callback URL in Cognito
  const googleProvider = "Google";

  const handleSignup = async (event) => {
    event.preventDefault();
    if (!firstname.trim() || !lastname.trim() || !username.trim() || !email.trim() || !password.trim()) {
      setPopup({
        open: true,
        message: "All fields are required. Please fill in all fields.",
      });
      return;
    }

    try {
      // const data = await AuthService.signUp(username, email, password);
      const doesEmailExist = await emailValidation(email);
      if (doesEmailExist?.data?.response === 'exist') {
        setPopup({
          open: true,
          message: "This email is already registered. Try logging in.",
        });
        return;
      }
      signUp(username, email, password)
        .then(result => {
          setUserId(result.userSub);
          setIsConfirming(true);
        })
        .catch(err => {
          if (err.code === "UsernameExistsException") {
            setPopup({
              open: true,
              message: "It looks like this username is already taken. Please try a different one",
            });
          } else {
            console.error("Sign-up error:", err);
            setPopup({
              open: true,
              message: err.message,
            });
          }
        });
      // if (data.UserConfirmed === false) {
      //   setIsConfirming(true);
      // } else {
      //   alert("Error signing up: " + data.message);
      // }
    } catch (err) {
      console.error("Signup error:", err);
      setPopup({
        open: true,
        message: err.message,
      });
      // alert("Error signing up: " + err.message);
    }
  };

  const handleConfirmSignup = async (event) => {
    event.preventDefault();
    if (!username.trim() || !confirmationCode.trim()) {
      setPopup({
        open: true,
        message: "Username and confirmation code are required.",
      });
      return;
    }
    try {
      const result = await confirmSignUp(username, confirmationCode);
      await setMfaToEmail(username, password);
      const payload = {
        "UserID": userId,
        "UserName": username,
        "Email": email,
        "FirstName": firstname,
        "LastName": lastname
      };
      await handleUserSignup(payload);
      navigate("/login");
    } catch (err) {
      console.error("Confirmation error:", err);
      setPopup({
        open: true,
        message: "An error occurred during confirmation. Please try again later.",
      });
    }
  };

  const handleGoogleSignup = useGoogleLogin({
    flow: "popup", 
    onSuccess: async (tokenResponse) => {
      console.log("Token Response:", tokenResponse);
      try {
        const access_token = await exchangeGoogleCodeForToken(tokenResponse?.code);
        const userInfo = await fetchGoogleUserInfo(access_token);

        if (userInfo?.email === undefined) {
          setPopup({
            open: true,
            message: "Unable to retrieve the email. Please try again.",
          });
          return;
        }
        const payload = {
          "UserID": uuidv4(),
          "UserName": userInfo?.email.split('@')[0],
          "Email": userInfo?.email,
          "FirstName": userInfo?.given_name,
          "LastName": userInfo?.family_name
        };
        const doesEmailExist = await emailValidation(userInfo?.email);
        if (doesEmailExist?.data?.response === 'exist') {
          setPopup({
            open: true,
            message: "This email is already registered. Try logging in.",
          });
          return;
        }
        await handleUserSignup(payload);
        localStorage.setItem('user_id', payload?.UserID);
        
        // navigate("/home");
        navigate("/login");
      } catch (error) {
        console.error("Handle Google Sign up failure:", error);
        setPopup({
          open: true,
          message: error?.message? error.message : 'Unable to Create the User',
        });
      }
    },
    onError: (error) => {
      console.error("Google Login Failed:", error);
    },
  });


  const handleAppleSignUp = async () => {
    // Check if the Apple script is loaded
    if (!window.AppleID) {
      console.error('Apple Sign-In script is not loaded yet.');
      return;
    }
  
    try {
      // Initialize Apple Sign-In
      window.AppleID.auth.init({
        clientId: process.env.REACT_APP_APPLE_CLIENT_ID,
        scope: 'email', // Requested scopes
        redirectURI: process.env.REACT_APP_APPLE_REDIRECT_URL,
        state: 'state',
        usePopup: true,
      });
  
      // Sign in with Apple
      const response = await window.AppleID.auth.signIn();

      // Extract details from the response
      const { authorization } = response;
      const { email, name } = authorization.user || {};

      console.log('authorization: ', authorization);
  
      // Decode the JWT to get additional details (if needed)
      const decodedToken = authorization.id_token;

      console.log('decodedToken: ', decodedToken);
  
     const doesEmailExist = await emailValidation(email);
  
      if (doesEmailExist?.data?.response === 'exist') {
        // If the email exists, prompt the user to log in
        alert('An account with this email already exists. Please log in.');
        navigate("/login"); // Redirect to the login page
      } else {
        const payload = {
          UserID: decodedToken.sub, // Unique user identifier from Apple
          UserName: email, // Use email as the username if no username is provided
          Email: email,
          FirstName: name?.firstName || '', // First name (if provided)
          LastName: name?.lastName || '', // Last name (if provided)
        };
        console.log('payload: ', payload);
        
        await handleUserSignup(payload);
  
        // if (signUpResponse.ok) {
          // Redirect to the home page after successful signup
          // navigate("/home");
          navigate("/login");
        // } else {
        //   console.error('Signup failed:', await signUpResponse.json());
        // }
      }
    } catch (error) {
      console.error('Apple Sign-In Error:', error);
    }
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
    script.async = true;
    script.onload = () => {
      console.log('Apple Sign-In script loaded successfully.');
      setIsScriptLoaded(true); // Set a state to indicate the script is loaded
    };
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script); // Clean up the script when the component unmounts
    };
  }, []);

  const exchangeGoogleCodeForToken = async (authorizationCode) => {
    const tokenUrl = process.env.REACT_APP_GOOGLE_TOKEN_URL;

    const body = new URLSearchParams({
      code: authorizationCode,
      client_id: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID,
      client_secret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET,
      redirectUri: process.env.REACT_APP_GOOGLE_REDIRECT_URL,
      // redirectUri: "http://localhost:3000",
      grant_type: "authorization_code",
    });

    try {
      const response = await fetch(tokenUrl, {
        method: "POST",
        body: body,
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });

      const data = await response.json();

      if (response.ok) {
        console.log("Access Token:", data.access_token);
        console.log("ID Token:", data.id_token); // Optional: You can use the id_token to get user info
        return data.access_token; // You can use this token to make authenticated API requests
      } else {   
        throw new Error("Failed to exchange code for access token");
      }
    } catch (error) {
      console.error("Error exchanging code for token:", error);
    }
  };

  const fetchGoogleUserInfo = async (accessToken) => {
    const userInfoUrl = process.env.REACT_APP_GOOGLE_USER_INFO_URL;

    try {
      const response = await fetch(userInfoUrl, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const userInfo = await response.json();
      console.log("User Info:", userInfo);
      return userInfo;
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  const handleFacebookSignUp = () => {
    window.FB.getLoginStatus((response) => {
      if (response.status === "connected") {
        console.log("User already signed in. Logging out first...");
        window.FB.logout(() => {
          console.log("Logged out. Now showing sign-up popup...");
          openFacebookSignUp();
        });
      } else {
        openFacebookSignUp();
      }
    });
  };
  
  const openFacebookSignUp = () => {
    window.FB.login(
      function (response) {
        if (response.authResponse) {
          console.log("Sign-up successful! Fetching user data...");
          fetchFacebookUser();
        } else {
          console.log("User cancelled sign-up. Logging out...");
          window.FB.logout(); // 🔥 Logs out to prevent auto-login if user closes popup
        }
      },
      { scope: "email,public_profile", auth_type: "reauthenticate", display: "popup" }
    );
  };
  
  const fetchFacebookUser = () => {
    window.FB.api("/me", { fields: "email,first_name,last_name" }, async function (user) {
      console.log("User data received:", user);
      
      if (!user?.email) {
        console.error("Unable to retrieve the email. Logging out...");
        window.FB.logout(); // 🔥 Logs out to prevent auto-login with partial data
        setPopup({
          open: true,
          message: "Unable to retrieve the email. Please try again.",
        });
        return;
      }
  
      const payload = {
        UserID: uuidv4(),
        UserName: user?.email.split("@")[0],
        Email: user?.email,
        FirstName: user?.first_name,
        LastName: user?.last_name,
      };
      console.log('payload: ', payload)
      const doesEmailExist = await emailValidation(user?.email);
      if (doesEmailExist?.data?.response === "exist") {
        console.log("Email already exists. Logging out...");
        window.FB.logout(); // 🔥 Ensures previous session is cleared before retry
        localStorage.removeItem("user_id"); // 🚀 Removes cached user ID
        setPopup({
          open: true,
          message: "This email is already registered. Try logging in.",
        });
        return;
      }
  
      // 🚀 New User - Proceed with Sign-Up
      await handleUserSignup(payload);
      localStorage.setItem("user_id", payload.UserID);
      // navigate("/home");
      navigate("/login");
    });
  };  


  const isPasswordValid = () => {
    const { minLength, hasNumber, hasSpecialChar, hasUppercase, hasLowercase } = passwordValidation;
    const isValid = minLength && hasNumber && hasSpecialChar && hasUppercase && hasLowercase;
    return isValid;
  };

  const validatePassword = (password) => {
    setPasswordValidation({
      minLength: password.length >= 8,
      hasNumber: /\d/.test(password),
      hasSpecialChar: /[!@#$%^&*]/.test(password),
      hasUppercase: /[A-Z]/.test(password),
      hasLowercase: /[a-z]/.test(password)
    });
  };

  const renderValidationIcon = (isValid) => {
    const hasUserInput = password.length > 0;
    
    let color;
    if (!hasUserInput) {
      color = passwordValidationStyles.dotColors.inactive;
    } else if (isValid) {
      color = passwordValidationStyles.dotColors.valid;
    } else {
      color = passwordValidationStyles.dotColors.invalid;
    }
    
    return (
      <div 
        style={{
          ...passwordValidationStyles.dotBase,
          borderColor: color,
          backgroundColor: color,
        }}
      ></div>
    );
  };

  const login = () => {
    navigate("/login");
  };

  return (
    <div className="clr-white" style={{ height: '100vh', overflow: 'hidden' }}>
      <div className="container-fluid" style={{ height: '100%' }}>
        <div className="row theme-bg" style={{ height: '100%' }}>
          <div className="col-xl-7 col-lg-6">
            {/* <div className="logo-container">
              <img src={logo} alt="Dyrect Logo" className="logo-image" />
              <span className="logo-text">yrect</span>
            </div> */}
            <div className="welcome-grid" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', height: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'stretch',marginLeft:"15%",gap:"1.6vh" }}>
                <div style={{ position: 'relative', display: 'inline-block'}}>
                  <img src={arrowSignup} alt="Arrow" className="arrow-signup"/>
                  <LogoAnimation />
                </div>
                <h1 className="logo-text-signup">yrect</h1>
              </div>
            </div>
            <div className="ellipse-signup" />
          </div>
          <div className="col-xl-5 col-lg-6" style={{ zIndex: "1000", display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2vh 0' }}>
            <div className="login-grid" style={{ margin: '2vh auto', maxWidth: '90%' }} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); const active = document.activeElement; if (isConfirming) { if (confirmCodeRef.current?.contains(active)) { handleConfirmSignup(); } else { confirmCodeRef.current?.querySelector('input')?.focus(); } } else { if (signupPasswordRef.current?.contains(active)) { if (isPasswordValid()) handleSignup(); } else if (signupEmailRef.current?.contains(active)) { signupPasswordRef.current?.querySelector('input')?.focus(); } else if (signupUsernameRef.current?.contains(active)) { signupEmailRef.current?.querySelector('input')?.focus(); } else if (lastNameRef.current?.contains(active)) { signupUsernameRef.current?.querySelector('input')?.focus(); } else { lastNameRef.current?.querySelector('input')?.focus(); } } } }}>
              <h2 className="login-title">{isConfirming ? "Confirm Sign-Up" : "Signup"}</h2>
              <p className="login-subtitle">
                {isConfirming
                  ? "Enter the confirmation code sent to your email."
                  : "Create your account"}
              </p>

              {isConfirming ? (
                <>
                  <FormControl fullWidth sx={{ marginBottom: '0.8vh' }}>
                    <FormLabel sx={{ color: '#FFFFFF', fontSize: '1.4vh', fontWeight:'100',marginBottom: '0.4vh',marginLeft: '1.6vh' }}>
                      Username
                    </FormLabel>
                    <TextField
                      variant="outlined"
                      placeholder="Enter your username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      sx={inputFieldStyles}
                    />
                  </FormControl>
                  <FormControl fullWidth sx={{ marginBottom: '0.8vh' }}>
                    <FormLabel sx={{ color: '#FFFFFF', fontSize: '1.4vh', fontWeight:'100',marginBottom: '0.4vh',marginLeft: '1.6vh' }}>
                      Confirmation Code
                    </FormLabel>
                    <TextField
                      variant="outlined"
                      placeholder="Enter confirmation code"
                      value={confirmationCode}
                      onChange={(e) => setConfirmationCode(e.target.value)}
                      ref={confirmCodeRef}
                      sx={inputFieldStyles}
                    />
                  </FormControl>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    className="login-button"
                    onClick={handleConfirmSignup}
                    sx={buttonStyles.primary}
                  >
                    Confirm Sign-Up
                  </Button>
                </>
              ) : (
                <div>
                  <div style={{ display: 'flex', gap: '1.6vh', }}>
                  <FormControl fullWidth sx={{ marginBottom: '0.8vh' }}>
                    <FormLabel sx={{ color: '#FFFFFF', fontSize: '1.4vh', fontWeight:'100',marginBottom: '0.4vh',marginLeft: '1.6vh'}}>
                      First Name
                    </FormLabel>
                    <TextField
                      size="small"
                      placeholder="Enter first name"
                      value={firstname}
                      onChange={(e) => setFirstname(e.target.value)}
                      sx={smallInputFieldStyles}
                    />
                  </FormControl>
                  <FormControl fullWidth sx={{ marginBottom: '0.8vh' }}>
                    <FormLabel sx={{color: '#FFFFFF', fontSize: '1.4vh', fontWeight:'100',marginBottom: '0.4vh',marginLeft: '1.6vh'}}>
                      Last Name
                    </FormLabel>
                    <TextField
                      size="small"
                      placeholder="Enter last name"
                      value={lastname}
                      onChange={(e) => setLastname(e.target.value)}
                      ref={lastNameRef}
                      sx={smallInputFieldStyles}
                    />
                  </FormControl>
                  </div>
                  <FormControl fullWidth sx={{ marginBottom: '0.8vh' }}>
                    <FormLabel sx={{color: '#FFFFFF', fontSize: '1.4vh', fontWeight:'100',marginBottom: '0.4vh',marginLeft: '1.6vh'}}>
                      Username
                    </FormLabel>
                    <TextField
                      placeholder="Create a username"
                      onChange={(e) => setUsername(e.target.value)}
                      ref={signupUsernameRef}
                      sx={inputFieldStyles}
                    />
                  </FormControl>
                  <FormControl fullWidth sx={{ marginBottom: '0.8vh' }}>
                    <FormLabel sx={{ color: '#FFFFFF', fontSize: '1.4vh', fontWeight:'100',marginBottom: '0.4vh',marginLeft: '1.6vh' }}>
                      Email
                    </FormLabel>
                    <TextField
                      placeholder="Enter your email"
                      onChange={(e) => setEmail(e.target.value)}
                      ref={signupEmailRef}
                      sx={inputFieldStyles}
                    />
                  </FormControl>
                  <FormControl fullWidth sx={{ marginBottom: '0.8vh' }}>
                    <FormLabel sx={{color: '#FFFFFF', fontSize: '1.4vh', fontWeight:'100',marginBottom: '0.4vh',marginLeft: '1.6vh' }}>
                      Password
                    </FormLabel>
                    <TextField
                      type="password"
                      placeholder="Create a password"
                      value={password}
                      ref={signupPasswordRef}
                      onChange={(e) => {
                        setPassword(e.target.value);
                        validatePassword(e.target.value);
                      }}
                      sx={inputFieldStyles}
                    helperText={
                        <PasswordValidationHelper 
                          passwordValidation={passwordValidation} 
                          renderValidationIcon={renderValidationIcon} 
                        />
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip title="Create a strong password with a mix of letters, numbers and symbols">
                              <IconButton sx={{ padding: '0.6vh' }}>
                                <FontAwesomeIcon icon={faInfoCircle} style={{ color: "#6c757d", fontSize: '2.4vh' }} />
                              </IconButton>
                            </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>

                  {/* <FormControl fullWidth sx={{ marginBottom: '8px' }}>
                    <FormLabel sx={{ color: '#FFFFFF', fontSize: '12px', fontWeight:'100',marginBottom: '4px',marginLeft: '16px' }}>
                      Confirm Password
                    </FormLabel>
                    <TextField
                      type="password"
                      placeholder="Re-enter your password"
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '16px',
                        '& fieldset': {
                          borderColor: '#FFFFFF',
                        },
                        '&:hover fieldset': {
                          borderColor: '#FFFFFF',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#FFFFFF',
                        },
                      },
                    }}
                      helperText={
                        <div className="invoice-popup-container mt-3">
                          <h6>Password requirements</h6>
                          <div>
                            {renderValidationIcon(passwordValidation.minLength)} Minimum length (8 characters) <br />
                            {renderValidationIcon(passwordValidation.hasNumber)} Contains at least 1 number <br />
                            {renderValidationIcon(passwordValidation.hasSpecialChar)} Contains at least 1 special character <br />
                            {renderValidationIcon(passwordValidation.hasUppercase)} Contains at least 1 uppercase letter <br />
                            {renderValidationIcon(passwordValidation.hasLowercase)} Contains at least 1 lowercase letter
                          </div>
                        </div>
                      }
                    />
                  </FormControl> */}
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    className="login-button"
                    onClick={handleSignup}
                    disabled={!isPasswordValid()}
                    sx={buttonStyles.primary}
                  >
                    Sign Up
                  </Button>
                </div>
              )}

              <div className="or-section">
                <span>Or</span>
              </div>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.6vh'}}>
              <div style={{fontSize: '1.6vh'}}>Login with</div>
              <div className="social-icons">
                <IconButton aria-label="Google" className="social-icon google" onClick={handleGoogleSignup}>
                  <img src={faGoogle} alt="Google" style={{ width: "4vh", height: "4vh" }} />
                </IconButton>
                <IconButton
                  aria-label="Facebook"
                  className="social-icon facebook"
                  onClick={handleFacebookSignUp}
                >
                  <img src={faFacebook} alt="Facebook" style={{ width: "4vh", height: "4vh" }} />
                </IconButton>
                <IconButton aria-label="Apple" className="social-icon apple" onClick={handleAppleSignUp} disabled={!isScriptLoaded} >
                  <FontAwesomeIcon icon={faApple} style={{ color: "#ffffff", fontSize: "4vh" }} />
                </IconButton>
              </div>
              </div>
              <p className="signup-text" style={{
                fontSize: '1.8vh',
              }}>
                Already registered? <button 
                  className="links" 
                  onClick={login}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      login();
                    }
                  }}
                  style={{
                    fontSize: '1.8vh',
                    fontWeight: 500,
                    cursor: 'pointer',
                    background: 'none',
                    border: 'none',
                    padding: 0,
                  }}
                  aria-label="Login to your account"
                >Login</button>
              </p>
              <div className="footer-links" style={{
                fontSize: '1.6vh',
              }}>
                <a href="javascript:void(0)">Terms & Conditions</a> <a href="javascript:void(0)">Support</a>{" "}
                <a href="javascript:void(0)">Customer Care</a>
              </div>
            </div>
          </div>
          <div className={isConfirming ? "bottom-ellipse-confirm-signup" : "bottom-ellipse-signup"}></div>
        </div>
        <ErrorModal
          open={popup.open}
          title={popup.title}
          message={popup.message}
          onClose={handlePopupClose}
        />
      </div>
    </div>
  );
}

export default Signup;
